import React from 'react';
import './Nav.css';
import { BrowserRouter as Router , NavLink , Route ,Switch } from 'react-router-dom'
import {Home} from '../Home.js';
import {MoreProject}  from '../../Projects/moreProject/moreProject.js';
export  function Nav (){


 

        return  <Router>
           <nav className="navbar navbar-expand-lg navbar-fixed navbar-light" >
             <div className='container'>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="true" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <NavLink exact activeClassName="active"  to="/"  className="navbar-brand" aria-current="page">KOTAM</NavLink>
    <div className=" collapse navbar-collapse" id="navbarTogglerDemo03">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 ">
        <li className="nav-item">
          <NavLink exact activeClassName="active"  to="/"  className="nav-link" aria-current="page">
          <i class="fas fa-home" style={{color:'#f05454'}}></i> Home
            </NavLink>
        </li>
        <li className="nav-item">
          <a    href="#About" className="nav-link" >
          <i class="fas fa-address-card" style={{color:'#f05454'}}></i> About
            </a>
        </li>  
        <li className="nav-item">
          <a    href="#Work" className="nav-link" >
          <i class="fas fa-code" style={{color:'#f05454'}}></i> Work
            </a>
        </li>
        <li className="nav-item">
          <a   href="#Contact" className="nav-link" >
          <i class="far fa-envelope" style={{color:'#f05454'}}></i> Contact
            </a>
        </li>
      </ul>  
    </div>
    </div>
    
        
</nav>

        <Switch>
      <Route path="/" component={Home} exact />
      <Route path={'/Home/:id'} extact component={MoreProject} />
     </Switch>  
   </Router>
}

  